<template>
  <div class="accordion-item">
    <h2 class="accordion-header" id="summary-accordion-header">
      <button class="accordion-button collapsed"
        :class="{ collapsed: !isActive }"
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#summary-accordion-body" 
        :aria-expanded="isActive"
        aria-controls="summary-accordion-body"
        :disabled="!wizardStore.isStepEnabled(4)">
        4. {{ $t("Oppsummering") }}
        <span class="fa fa-check float-right text-success ms-2"
          :class="{ 'd-none': !wizardStore.isStepCompleted(4) }"
          style="line-height: 24px"></span>
      </button>
    </h2>

    <div id="summary-accordion-body"
      class="accordion-collapse collapse"
      :class="{ show: isActive }"
      data-bs-parent="#booking-accordions">
      <div class="accordion-body">
          <div>{{ $t("Eleven har blitt registrert hos skolen.") }}</div>

          <div>
              <a class="btn btn-primary mt-2" href="/login">{{ $t('Gå til innlogging') }}</a>
          </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import wizardStore from '../../state/vippsWizardStore.js'

const props = defineProps({
  isActive: Boolean
})
</script>
